let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ezx7u")).then(() => parcelRequire('5BB9g'));